// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3Ns63","author":"Table_author__1wGIJ","authorImage":"Table_authorImage__2dqOI","unreadRow":"Table_unreadRow__2vAvm"};